/* tslint:disable */


export default {
    apiContextPath: API_CONTEXT_PATH,
    reportCenterPath: REPORT_CENTER_PATH
}
